function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item))
      return
    }

    searchParams.append(key, value)
  })

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

export default async function request(config) {
  const {
    url,
    method = 'get',
    params,
    data,
    headers = {}
  } = config

  const requestPath = `${url}${buildQueryString(params)}`
  const nodeApiBaseUrl = typeof process !== 'undefined'
    ? process.env?.VUE_APP_BASE_URL
    : ''
  const apiBaseUrl = typeof window === 'undefined'
    ? (nodeApiBaseUrl || import.meta.env.VUE_APP_BASE_URL || 'https://api.huahuaeco.com')
    : ''
  const requestUrl = requestPath.startsWith('/')
    ? `${apiBaseUrl}${requestPath}`
    : requestPath
  const upperMethod = method.toUpperCase()
  const fetchOptions = {
    method: upperMethod,
    headers: {
      ...headers
    }
  }

  if (data !== undefined && upperMethod !== 'GET') {
    fetchOptions.headers['Content-Type'] = 'application/json'
    fetchOptions.body = JSON.stringify(data)
  }

  const response = await fetch(requestUrl, fetchOptions)
  const contentType = response.headers.get('content-type') || ''
  const responseData = contentType.includes('application/json')
    ? await response.json()
    : await response.text()

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`)
    error.response = responseData
    throw error
  }

  return responseData
}
